import { create } from "zustand";
// Define the Zustand store for SideSheet

interface ToastState {
  isOpen: boolean;
  id:string;
  type:string;
  message:string;
  openToast: (id:string,type:string,message:string) => void;
  resetToast: () => void;
}

// Create Zustand store
export const useToastStore = create<ToastState>((set) => ({
  isOpen: false,
  content: null,
  id: '',
  type: '',
  message: '',
  openToast: (id:string,type:string,message:string) => set({ isOpen: true, id, type,message }),
  resetToast: () => set({ isOpen: false,id:'', type:'',message:''}),
}));
